module.exports = __webpack_public_path__ + "static/media/bacterium-laranja.ba337db7.svg";